import { Component } from '@angular/core';

@Component({
  standalone: true,
  selector: 'app-logo-bestegg-white',
  templateUrl: './logo-bestegg-white.component.html',
})
export class LogoBestEggWhiteComponent {}
